import {
  ELEC_EMISSION_FACTOR_MT_PER_KWH,
  GAS_EMISSION_FACTOR_MT_PER_THERM,
} from './bhSourceControls';
import type { ActivityEstimate, CanonicalEnergyActivityYear, EnergySector } from './types';

export function activityMtCo2e(activity: ActivityEstimate, fuel: 'electricity' | 'natural_gas'): number | null {
  if (activity.value == null || !Number.isFinite(activity.value)) return null;
  const factor =
    fuel === 'electricity' ? ELEC_EMISSION_FACTOR_MT_PER_KWH : GAS_EMISSION_FACTOR_MT_PER_THERM;
  return activity.value * factor;
}

export function experimentalEmissionsForSector(
  row: CanonicalEnergyActivityYear,
  sector: EnergySector
): number | null {
  const estimate =
    sector === 'residential'
      ? row.residential
      : sector === 'commercial'
        ? row.commercial
        : sector === 'industrial'
          ? row.industrial
          : sector === 'nonresidential'
            ? row.nonresidential
            : sector === 'total'
              ? row.total
              : null;
  if (!estimate) return null;
  return activityMtCo2e(estimate, row.fuel);
}
